import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

const SitemapBanner = () => {
    return (
        <Fragment>
            <div className="container faqbanner homemenu sitemap-banner">
                <div className="row">
                    <div className="col-sm-12">
                        {/* Breadcrumb / Navigation line */}
                        <nav className="sitemap-breadcrumb" aria-label="Breadcrumb">
                            <ol className="sitemap-breadcrumb-list">
                                <li className="sitemap-breadcrumb-item">
                                    <Link to="/" className="sitemap-breadcrumb-link">Home</Link>
                                </li>
                                <li className="sitemap-breadcrumb-sep" aria-hidden="true">/</li>
                                <li className="sitemap-breadcrumb-item sitemap-breadcrumb-current" aria-current="page">Sitemap</li>
                            </ol>
                        </nav>
                        <h2>Sitemap</h2>
                        <p className="mt-3">Navigate through all pages of our website</p>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default SitemapBanner
